// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lfc62lV_yyc5BU2DpMH26{padding:.35714rem}._1zBEit5FVTi5nkOkYovuqh{background:transparent;height:100%;top:0;right:0;width:.28571rem !important}._1xrhjh4v8hdH5iVnxMBKKt{background:#e6d7fd;border-radius:1.07143rem;cursor:pointer}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollbar__content": "lfc62lV_yyc5BU2DpMH26",
	"scrollbar__trackY": "_1zBEit5FVTi5nkOkYovuqh",
	"scrollbar__thumbY": "_1xrhjh4v8hdH5iVnxMBKKt"
};
export default ___CSS_LOADER_EXPORT___;
